import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import Accordion from "./Classes/Accordion.js";
import Video from "./Classes/Video.js";
import HeroSlider from "./Classes/HeroSlider.js";
import DrawHighcharts from "./Classes/DrawHighcharts";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import RegisterTab from './Classes/RegisterTab.js';
import Gri from "./Classes/Gri"

var heroSliderInstance = null;

window.addEventListener("page_event_load", () => {
  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new Video();

  new Swiper(".lc-keyfigure-slider .lc-keyfigure-slider__container", {
    modules: [Navigation],
    paginationClickable: true,
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 50,
        slidesPerView: 2
      }
    },
  });

  new DrawHighcharts();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new RegisterTab();

  heroSliderInstance = new HeroSlider();

  new Gri();
});

window.addEventListener('page_event_unloading', () => {
  heroSliderInstance?.unbindEvents();
  heroSliderInstance = null;
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});

window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
